/* Marcacion Evento Estándar: Click en Continuar seleccionar otro departamento */
export const marcacionPortEnviarCodigo = async ({
  phoneNumber,
  plan,
  valor,
}) => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "formulario_portabilidad_prepago",
      celular: phoneNumber,
      plan: plan,
      valor: valor,
      flujo: "paso-1 test",
    });
  }
};

/* Marcacion Evento Pagename: Inicio */
export const marcacionPortGeneral = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "virtualPageview",
      pageName: "Portabilidad inicio",
    });
  }
};

/* Marcacion Evento Estándar: Nombre Form */
export const marcacionPortNombre = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Nombres",
    });
  }
};

/* Marcacion Evento Estándar: Apellidos Form  */
export const marcacionPortApellido = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Apellidos",
    });
  }
};

/* Marcacion Evento Estándar: Email Form */
export const marcacionPortEmail = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Correo electronico",
    });
  }
};

/* Marcacion Evento Estándar: Linea que cambias a movistar Form */
export const marcacionPortPhoneNumber = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "línea que cambias a movistar",
    });
  }
};

/* Marcacion Evento Estándar: Tipo de documento Form */
export const marcacionPortTipoDocumento = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "tipo de documento",
    });
  }
};

/* Marcacion Evento Estándar: Numero de documento Form */
export const marcacionPortDocument = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "número de documento",
    });
  }
};

/* Marcacion Evento Estándar: Día de expedición */
export const marcacionPortDiaExpedicion = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "día",
    });
  }
};

/* Marcacion Evento Estándar: Mes de Expedición */
export const marcacionPortMesExpedicion = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "mes",
    });
  }
};

/* Marcacion Evento Estándar: Año de expedición */
export const marcacionPortAnoExpedicion = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "año",
    });
  }
};

/* Marcacion Evento Estándar: Día de nacimiento */
export const marcacionPortDiaBirth = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "díaNacimiento",
    });
  }
};

/* Marcacion Evento Estándar: Mes de nacimiento */
export const marcacionPortMesBirth = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "mesNacimiento",
    });
  }
};

/* Marcacion Evento Estándar: Año de nacimiento */
export const marcacionPortAnoBirth = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "añoNacimiento",
    });
  }
};

/* Marcacion Evento Estándar:  */
export const marcacionPortTratamientoDatosPersonales = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Acepto el tratamiento de mis datos personales",
    });
  }
};

/* Marcacion Evento Estándar: Boton Continuar */
export const marcacionPortBotonContinuar = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Continuar_paso1",
    });
  }
};

/* Marcacion Evento Estándar: Al deslizar detalles de tu compra */
export const marcacionPortDetallesCompra = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Detalles de tu compra",
    });
  }
};

/* Marcacion Evento Estándar: Al cerrar detalles de tu compra */
export const marcacionPortCerrarDetallesCompra = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Detalles de tu compra_plegar",
    });
  }
};

/* Marcacion Evento Estándar: Continuar en el codigo de verificación */
export const marcacionPortCodigoVerificacion = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Confirmar_código verificación",
    });
  }
};

/* Marcacion Evento Estándar: Reenviar codigo */
export const marcacionPortReenviarCodigo = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Reenviar código",
    });
  }
};

/* Marcacion Evento Estándar: Recibir a domicilio */
export const marcacionPortRecibirDomicilio = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Recibir a domicilio gratis",
    });
  }
};

/* Marcacion Evento Estándar: Al desplegar departamento */
export const marcacionPortDepartamento = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "departamento",
    });
  }
};

/* Marcacion Evento Estándar: Al desplegar ciudad */
export const marcacionPortCiudad = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "ciudad",
    });
  }
};

/* Marcacion Evento Estándar: Al desplegar municipio */
export const marcacionPortMunicipio = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "municipio",
    });
  }
};

/* Marcacion Evento Estándar: Al desplegar barrio */
export const marcacionPortBarrio = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Barrio",
    });
  }
};

/* Marcacion Evento Estándar: Al desplegar tipo de calle */
export const marcacionPortTipoCalle = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "tipo de calle",
    });
  }
};

/* Marcacion Evento Estándar: Al desplegar Calle */
export const marcacionPortCalle = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "calle",
    });
  }
};

/* Marcacion Evento Estándar: Al dar click en el input de direccion con numeral */
export const marcacionPortDireccionNumeral = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "dirección-1",
    });
  }
};

/* Marcacion Evento Estándar: Al dar click en el input de direccion con guion */
export const marcacionPortDireccionGuion = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "dirección-2",
    });
  }
};

/* Marcacion Evento Estándar: solo al titular */
export const marcacionPortTitular = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "solo al titular",
    });
  }
};

/* Marcacion Evento Estándar: En porteria */
export const marcacionPortPorteria = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "En portería",
    });
  }
};

/* Marcacion Evento Estándar: Retirar en tienda Movistar */
export const marcacionPortTienda = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Retirar en tienda Movistar",
    });
  }
};

/* Marcacion Evento Estándar: selección departamento en retiro en tienda */
export const marcacionPortTiendaDepartamento = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "selección departamento",
    });
  }
};

/* Marcacion Evento Estándar: selección ciudad en retiro en tienda */
export const marcacionPortTiendaCiudad = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "selección ciudad",
    });
  }
};

/* Marcacion Evento Estándar: seleccion municipio en retiro en tienda */
export const marcacionPortTiendaMunicipio = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "municipio",
    });
  }
};

/* Marcacion Evento Estándar: Continuar en recogida de sim */
export const marcacionPortContinuarRecogidaSim = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Continuar_como quieres recibir tu sim",
    });
  }
};

/* Marcacion Evento Estándar: Click en continuar en tiendas mas cercanas */
export const marcacionPortContinuarTiendasCercanas = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Continuar_tiendas cercanas",
    });
  }
};

/* Marcacion Evento Estándar: Click en si eliminar orden */
export const marcacionPortEliminarOrden = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Sí eliminar orden y continuar",
    });
  }
};

/* Marcacion Evento Estándar: Click en no quiero mantener mi orden */
export const marcacionPortMantenerOrden = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "No-quiero pagar mi orden pendiente",
    });
  }
};

/* Marcacion Evento Estándar: Click en Continuar seleccionar otro departamento */
export const marcacionPortDeptoDomicilio = async () => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "trackEvent",
      eventCategory: "Portabilidad Prepago",
      eventAction: "click",
      eventLabel: "Continuar_depta_no entrega a domicilio",
    });
  }
};

/* Marcacion Evento Estándar: Click en Continuar seleccionar otro departamento */
export const marcacionPortModalNip = async ({ phoneNumber, plan, valor }) => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: "formulario_portabilidad_prepago",
      celular: phoneNumber,
      plan: plan,
      valor: valor,
      flujo: "paso-1.1",
    });
  }
};

export const marcacionValidarIdentidad = async ({
  phoneNumber,
  plan,
  valor,
  app,
}) => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: app,
      celular: phoneNumber,
      plan: plan,
      valor: valor,
      flujo: "paso-1.0",
    });
  }
};

export const marcacionValidarEnvio = async ({ app, plan, valor }) => {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname) && window.dataLayer) {
    window.dataLayer.push({
      event: app,
      plan: plan,
      valor: valor,
      flujo: "paso-2.0",
    });
  }
};